/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Online_Price_Col_WebInputs */

const vi_online_price_col_web = /** @type {(inputs: Online_Price_Col_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website đang bán`)
};

/**

* @param {Online_Price_Col_WebInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const online_price_col_web = /** @type {((inputs?: Online_Price_Col_WebInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_Price_Col_WebInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_online_price_col_web(inputs)
});